import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';

type StyleType = 'normal' | 'italic';
type WeightType = 'normal' | 'bold';

export type FontConfigJson =  {
  size: number;
  style: StyleType;
  weight: WeightType;
  lineHeight: string | number;
};

export class FontConfig implements JsonConfigInterface<FontConfigJson> {

  private _size: number = 0;
  private _style: StyleType = 'normal';
  private _weight: WeightType = 'normal';
  private _lineHeight: string | number = '100%';

  constructor(json?: FontConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get size(): number {
    return this._size;
  }

  public get style(): StyleType {
    return this._style;
  }

  public get weight(): WeightType {
    return this._weight;
  }

  public get lineHeight(): string | number {
    return this._lineHeight;
  }

  public deserializeJson(json: FontConfigJson): void {
    this._size = json.size;
    this._style = json.style;
    this._weight = json.weight;
    this._lineHeight = json.lineHeight;
  }
}
